import { getAllTracksHeight } from "../../main-canvas/utils.ts";
import { MIN_HORIZONTAL_SCROLLBAR_WIDTH, MIN_VERTICAL_SCROLLBAR_WIDTH } from "../../settings.ts";

export function getVerticalScrollbarY(canvasHeight: number, scrollY: number) {
  const allTracksHeight = getAllTracksHeight();
  return (scrollY / (allTracksHeight - canvasHeight)) * (canvasHeight - getVerticalScrollbarHeight(canvasHeight));
}

export function getHorizontalScrollbarX(scrollX: number, maxWidth: number, canvasWidth: number) {
  const divisor = maxWidth - canvasWidth;
  if (divisor === 0) {
    return 0;
  }
  return (scrollX / divisor) * (canvasWidth - getHorizontalScrollbarWidth(maxWidth, canvasWidth));
}

export function getVerticalScrollbarHeight(canvasHeight: number) {
  const allTracksHeight = getAllTracksHeight();
  if (allTracksHeight === 0) {
    return MIN_VERTICAL_SCROLLBAR_WIDTH;
  }
  return Math.max(MIN_VERTICAL_SCROLLBAR_WIDTH, (canvasHeight / allTracksHeight) * canvasHeight);
}

export function getHorizontalScrollbarWidth(maxWidth: number, canvasWidth: number) {
  if (maxWidth === 0) {
    return MIN_HORIZONTAL_SCROLLBAR_WIDTH;
  }
  return Math.max(MIN_HORIZONTAL_SCROLLBAR_WIDTH, (canvasWidth / maxWidth) * canvasWidth);
}

export function getCanvasCoordinates(e: MouseEvent | PointerEvent, rect: DOMRect) {
  return {
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  };
}

export function isVerticalScrollbarClicked(x: number, _y: number, canvasWidth: number) {
  return x >= canvasWidth - 10 && x <= canvasWidth;
}

export function isHorizontalScrollbarClicked(_x: number, y: number, canvasHeight: number) {
  return y >= canvasHeight - 10 && y <= canvasHeight;
}
